/**
 * bundle-progress.js — shared spend-reward track ("ticked checkpoints").
 *
 * One continuous track with a checkpoint dot per tier: reached dots become a
 * check, the next tier is ringed, $ labels sit underneath. Shared so the mini
 * cart and the PDP "Bundle & save" block draw the same bar from the same code.
 * Callers own their own state and messaging; this only paints into `mount`.
 *
 * Markup keeps the `cart__rewards__*` class names, styled by
 * bundle-cart-rewards.css (loaded globally) — style the track via those.
 *
 * Requires window.theme.bundleTiers (bundle-tiers.js).
 */
(function () {
  'use strict';

  const CHECK = '<svg class="cart__rewards__ck" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg>';

  // Draws the track once; no-op if the mount already holds one.
  function buildTrack(mount, BT, tiers) {
    if (mount.children.length) return;

    const topMin = tiers[tiers.length - 1].min;
    const track = document.createElement('div');
    track.className = 'cart__rewards__track';
    track.innerHTML = '<div class="cart__rewards__fill" data-rw-fill></div>' +
      '<div class="cart__rewards__ticks">' +
      tiers.map((t) =>
        '<div class="cart__rewards__tick" data-rw-tick data-min="' + t.min + '" style="left:' + ((t.min / topMin) * 100) + '%">' +
          '<span class="cart__rewards__dot">' + CHECK + '</span>' +
          '<span class="cart__rewards__lbl">' + BT.formatMoneyShort(t.min) + '</span>' +
        '</div>'
      ).join('') +
      '</div>';

    mount.appendChild(track);
  }

  /**
   * Paints the track. Safe to call repeatedly.
   * @param {HTMLElement} mount element the track lives in
   * @param {{total: number, tiers: Array<{min: number}>}} state total in cents
   */
  function render(mount, state) {
    const BT = window.theme && window.theme.bundleTiers;
    if (!mount || !BT || !state) return;

    const tiers = state.tiers;
    if (!tiers || !tiers.length) return;

    const total = state.total || 0;
    buildTrack(mount, BT, tiers);

    const topMin = tiers[tiers.length - 1].min;
    let next = null;
    for (let i = 0; i < tiers.length; i++) {
      if (total < tiers[i].min) { next = tiers[i]; break; }
    }

    const fill = mount.querySelector('[data-rw-fill]');
    if (fill) fill.style.width = Math.min(100, (total / topMin) * 100) + '%';

    mount.querySelectorAll('[data-rw-tick]').forEach((tick, i) => {
      const tier = tiers[i];
      if (!tier) return;
      tick.classList.toggle('is-reached', total >= tier.min);
      tick.classList.toggle('is-next', next !== null && tier.min === next.min);
    });
  }

  window.theme = window.theme || {};
  window.theme.bundleProgress = { render: render, checkIcon: CHECK };
})();
